<template>
  <div id="page-wrapper">
    <!-- Header -->
    <div id="header" :style="{ backgroundImage: `url(${currentBackground})` }">
      <!-- Inner -->
      <div class="inner animate__animated animate__zoomIn">
        <header>
          <h1><a id="logo">全国首家护工行业协会</a></h1>
          <hr />
          <p>护工职业生涯规划·企业运营风险管控·护工行业发展赋能</p>
        </header>
        <footer>
          <a class="button" @click="openVideoAndMask()">观看视频</a>
        </footer>
      </div>
      <!-- Nav -->
      <nav id="nav">
        <img
          class="imagetran"
          src="https://provide-street.oss-cn-shanghai.aliyuncs.com/app/image/36571d0c027841b6a16ad96fa941f355.png"
          alt=""
          @click="goLink('Home')"
        />
        <ul>
          <li
            :class="currentRouteName == 'Home' ? 'linkactive' : ''"
            :style="{
              '--after-width': currentRouteName == 'Home' ? '100%' : '0',
            }"
          >
            <router-link to="/">
              <a> 首页</a>
            </router-link>
          </li>
          <li
            :class="currentRouteName == 'policy' ? 'linkactive' : ''"
            :style="{
              '--after-width': currentRouteName == 'policy' ? '100%' : '0',
            }"
          >
            <router-link to="/policy">
              <a>政策法规</a>
            </router-link>
          </li>
          <li
            :class="currentRouteName == 'vipBox' ? 'linkactive' : ''"
            :style="{
              '--after-width': currentRouteName == 'vipBox' ? '100%' : '0',
            }"
          >
            <router-link to="/vipBox">
              <a>会员单位</a>
            </router-link>
          </li>
          <li
            :class="currentRouteName == 'newBox' ? 'linkactive' : ''"
            :style="{
              '--after-width': currentRouteName == 'newBox' ? '100%' : '0',
            }"
          >
            <router-link to="/newBox">
              <a>新闻动态</a>
            </router-link>
          </li>
          <li
            :class="currentRouteName == 'contact' ? 'linkactive' : ''"
            :style="{
              '--after-width': currentRouteName == 'contact' ? '100%' : '0',
            }"
          >
            <router-link to="/contact">
              <a> 联系我们</a>
            </router-link>
          </li>
          <li
            :class="currentRouteName == 'About' ? 'linkactive' : ''"
            :style="{
              '--after-width': currentRouteName == 'About' ? '100%' : '0',
            }"
          >
            <router-link to="/About">
              <a>关于协会</a>
            </router-link>
          </li>
          <li
            :class="currentRouteName == 'signUp' ? 'linkactive' : ''"
            :style="{
              '--after-width': currentRouteName == 'signUp' ? '100%' : '0',
            }"
          >
            <router-link to="/signUp">
              <a> 护工培训</a>
            </router-link>
          </li>
          <li
            :class="currentRouteName == 'zhaogong' ? 'linkactive' : ''"
            :style="{
              '--after-width': currentRouteName == 'zhaogong' ? '100%' : '0',
            }"
          >
            <router-link to="/zhaogong">
              <a> 招工需求</a>
            </router-link>
          </li>
        </ul>
      </nav>
    </div>
    <section id="banner">
      <VideoPlayerWithMask
        :isOpen="isVideoOpen"
        :showMask="isMaskVisible"
        @close="handleClose"
        @toggle-mask="toggleMaskVisibility"
      />
    </section>
    <!-- Banner -->
    <section id="banner">
      <header>
        <h2>关于协会</h2>
        <div class="bannerBox">
          <p class="p1">苏州市护工协会</p>
          <p class="p2">Suzhou Nursing Workers Association</p>
          <div class="p3"></div>
          <div class="p4">
            <p>
              全国首家：该协会是全国首家护工专业协会。目前，协会在苏州市范围内拥有108家会员单位，涵盖苏州大市范围内二甲以上医院40家，陪护企业33家及护理院（站）23家、长护险服务机构10家，共有从事医院陪护、护理院陪护、长护险家庭陪护等在册护工6300多名。
            </p>

            <p>
              全国首创：该协会在全国首创开展了护工意外和责任保险，为护工和病人增添了强有力的安全保障。
            </p>
          </div>
          <div class="p5">
            <div>
              <p><span>2019</span><text>年</text></p>
              <p>协会成立</p>
            </div>
            <div>
              <p><span>108</span>家</p>
              <p>会员单位</p>
            </div>
            <div>
              <p><span>6368</span>名</p>
              <p>在册护工</p>
            </div>
          </div>
          <footer>
            <a class="button" @click="goDetails('About', 39)">查看详情</a>
          </footer>
        </div>
      </header>
    </section>

    <!-- <section id="banner">
      <header class="headerBack">
        <h2>协会赋能</h2>
        <div class="xiehui">
          <img
            class="image"
            src="https://provide-street.oss-cn-shanghai.aliyuncs.com/app/image/fffb4cf6b43a4c779674a7e97dc781a6.png"
            alt=""
          />
        </div>
      </header>
    </section> -->

    <section id="banner">
      <header>
        <h2>新闻资讯</h2>
        <div class="bannerBox2">
          <ul>
            <li>
              <a :class="type == 33 ? 'active' : ''" @click="get_newsList(33)"
                >行业资讯</a
              >
            </li>
            <li>
              <a :class="type == 32 ? 'active' : ''" @click="get_newsList(32)"
                >协会动态</a
              >
            </li>
            <li>
              <a :class="type == 34 ? 'active' : ''" @click="get_newsList(34)"
                >招标信息</a
              >
            </li>
          </ul>
          <div class="main" v-if="list.length > 0">
            <div class="main_left">
              <!-- <img
                class="imagetran"
                :src="list[0].imageUrl ? list[0].imageUrl : src"
                alt=""
              /> -->
              <AnimatedImage
                class="imagetran"
                :imageSrc="list[0].imageUrl ? list[0].imageUrl : src"
              />
              <div class="main_left_text">
                <p class="p1">
                  {{ list[0].title }}
                </p>
                <div
                  class="buttonText"
                  @click="goDetails('newDetails', list[0].id)"
                >
                  查看详情
                </div>
              </div>
              <p class="p2">{{ list[0].releaseTime }}</p>
              <p class="p3">{{ list[0].remark1 }}</p>
            </div>
            <div class="rightBox">
              <div
                class="main_right"
                v-for="(item, index) of list"
                :key="index"
                @click="goDetails('newDetails', item.id)"
              >
                <template>
                  <div class="main_right_left">
                    <div class="p1">
                      {{ item.releaseTime | timeformat("posterDate") }}
                    </div>
                    <div class="p2">
                      {{ item.releaseTime | timeformat("poster1") }}
                    </div>
                  </div>
                  <div class="main_right_right">
                    <div class="p3">
                      {{ item.title }}
                    </div>
                    <div class="p4">
                      {{ item.remark1 }}
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </header>
    </section>

    <section id="banner">
      <header class="headerBack">
        <h2>会员单位</h2>
        <div class="vipBox">
          <el-carousel
            height="15.9em"
            :interval="10000"
            arrow="always"
            indicator-position="outside"
            @change="change"
          >
            <el-carousel-item v-for="(item, index) in list1" :key="index">
              <div class="vipFlex_left">
                <div
                  class="vipFlex_left_top_left"
                  v-for="(it, ind) in item"
                  :key="ind"
                >
                  <img
                    class="image imagetran"
                    :src="it.imageUrl ? it.imageUrl : src"
                  />
                </div>
                <div
                  v-for="i in 18 - item.length"
                  :key="`placeholder-${index}-${i}`"
                  class="placeholder"
                ></div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </header>
    </section>

    <Footer></Footer>
    <router-view></router-view>
  </div>
</template>
  
  
  <script>
import AnimatedImage from "./AnimatedImage.vue";
import "../assets/css/main.css";
import "../assets/css/noscript.css";
import { newsList } from "../api/index";
import Footer from "./Footer.vue";
import VideoPlayerWithMask from "./VideoPlayerWithMask.vue";

export default {
  name: "Home",
  components: {
    // 注册组件
    Footer,
    AnimatedImage,
    VideoPlayerWithMask,
  },
  data() {
    return {
      list: [],
      currentRouteName: "",
      src: "https://provide-street.oss-cn-shanghai.aliyuncs.com/app/image/3288746951724b2a82a91791d5e7e96d.png",
      total: 0,
      total1: 0,
      pageNum: 1,
      list1: [],
      type: 33,
      showVideoDialog: false,
      image:
        "https://provide-street.oss-cn-shanghai.aliyuncs.com/app/image/b516f4a77fc145dda71c6454c499b29e.png",
      currentIndex: 0,
      backgroundImages: [
        "https://provide-street.oss-cn-shanghai.aliyuncs.com/app/image/d2b31e2fe74c4dc5b762b40dbc108936.png",
        // "https://provide-street.oss-cn-shanghai.aliyuncs.com/app/image/3288746951724b2a82a91791d5e7e96d.png",
      ],
      isVideoOpen: false,
      isMaskVisible: false,
    };
  },
  computed: {
    currentBackground() {
      return this.backgroundImages[this.currentIndex];
    },
  },
  mounted() {
    this.$watch("showVideoDialog", async (newVal) => {
      if (newVal) {
        await this.$nextTick();
        const video = this.$refs.videoPlayer;
        try {
          await video.play();
          console.log("视频开始播放");
        } catch (error) {
          console.error("视频播放失败:", error);
        }
      } else {
        const video = this.$refs.videoPlayer;
        video.pause();
        video.currentTime = 0;
      }
    });
  },
  methods: {
    openVideoAndMask() {
      this.isVideoOpen = true;
      this.isMaskVisible = true;
    },
    handleClose() {
      this.isVideoOpen = false;
    },
    toggleMaskVisibility() {
      this.isMaskVisible = false;
    },
    goLook() {
      console.log("goLook");
      this.isVideoOpen = true;
      console.log(this.isVideoOpen);
    },
    goDetails(name, id) {
      this.$router.push({
        name: name,
        query: {
          id: id,
          name: "新闻动态",
          router: "newBox",
          image:
            "https://provide-street.oss-cn-shanghai.aliyuncs.com/app/image/9434bb03a43a47269d439666993d569b.png",
        },
      });
    },

    isActive(path) {
      console.log(path, this.$route.path);
      return this.$route.path === path;
    },
    get_newsList(type) {
      this.type = type;
      const params = {
        accId: 1,
        newType: type, //行业资讯
      };
      console.log(999, params);
      newsList(params, 1, 4).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.list = res.dataMap.list;
        } else {
          this.$message(res.message);
        }
      });
    },
    get_newsList1(type) {
      const params = {
        accId: 1,
        newType: type, //行业资讯
      };
      console.log(999, params);
      newsList(params, 1, 999).then((res) => {
        console.log(res);
        if (res.code == 200) {
          const list2 = res.dataMap.list;
          const list = [];
          list2.forEach((item) => {
            if (item.imageUrl) {
              list.push(item);
            }
          });
          this.list1 = [];
          for (let i = 0; i < list.length; i += 18) {
            this.list1.push(list.slice(i, i + 18));
          }
        } else {
          this.$message(res.message);
        }
      });
    },

    get_newsList3(type) {
      this.type = type;
      this.backgroundImages = [];
      const params = {
        accId: 1,
        newType: 31, //行业资讯
      };
      console.log(999, params);
      newsList(params, 1, 999).then((res) => {
        console.log(res);
        if (res.code == 200) {
          const list2 = res.dataMap.list;
          list2.forEach((el) => {
            if (el.imageUrl) {
              this.backgroundImages.push(el.imageUrl);
            }
          });
        } else {
          this.$message(res.message);
        }
      });
    },

    // change(e) {
    //   console.log(e);
    //   this.pageNum = e + 1;
    //   this.get_newsList1(70);
    // },
  },
  mounted() {
    this.currentRouteName = this.$route.name;
    this.get_newsList(this.type);
    this.get_newsList1(70);
    // this.get_newsList3()

    setInterval(() => {
      this.currentIndex =
        (this.currentIndex + 1) % this.backgroundImages.length;
    }, 5000);
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // 移除之前的动画类
          entry.target.classList.remove("animate__fadeIn");
          // 强制重绘以重置动画
          void entry.target.offsetWidth;
          // 添加动画类来触发新的动画
          entry.target.classList.add("animate__animated", "animate__fadeIn");
        } else {
          // 当元素离开视口，移除动画类
          entry.target.classList.remove("animate__fadeIn");
        }
      });
    });

    const animatedElements = document.querySelectorAll(
      ".main_right, .vipFlex_left_top_left, .bannerBox, .xiehui, .bannerBox2, .vipBox, h2"
    );
    animatedElements.forEach((element) => {
      observer.observe(element);
    });
  },
  created() {},
};
</script>
  
  <style>
.header-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  opacity: 0;
  transition: opacity 1s ease-in-out;
}

.header-background.active {
  opacity: 1;
}
.xiehui {
  /* margin-top: 4em; */
  padding: 3em 5em;
}
.xiehui .image {
  width: 100%;
  height: auto;
}

.linkactive {
  color: #0ba29a !important;
  font-weight: 600;
}

.headerBack {
  background-image: url("https://provide-street.oss-cn-shanghai.aliyuncs.com/app/image/b053ceb039054b72adb84cbb92759d61.png");
  background-size: cover;
  padding: 3em 0;
}
.vipBox {
  padding: 4.1em 6em;
}
.vipFlex_left {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.vipFlex_left_top_left {
  width: 20%;
  height: 4.5em;
  margin-bottom: 1.2em;
}

.vipFlex_left_top_left .image {
  width: 70%;
  aspect-ratio: 2/1;
}

.placeholder {
  width: 9em;
  height: 4.5em;
  margin-bottom: 1.2em;
  visibility: hidden;
}
.active {
  color: #0ba29a !important;
  font-weight: 600;
}

/* 动画样式 */
.fade-in {
  opacity: 1;
  transition: opacity 1.5s ease-in-out;
  transform: translateY(0);
  animation: fadeInUp 1s ease-in-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate__fadeIn {
  transition: opacity 1s ease; /* 添加过渡效果 */
}
</style>    